<template>
    <div style="padding-right: 1px" class="pa-4">
        <v-text-field v-model="search" :label="$translate('Search')" append-icon="mdi-magnify" single-line hide-details color="zoezi-edit-color" clearable />
        <v-list>
            <v-list-item-group color="zoezi-edit-color">
                <v-list-item
                    v-for="route in sortedRoutes"
                    :key="route.path"
                    :to="route.path"
                    exact-path
                >
                    <v-list-item-icon v-if="route.redirect">
                        <v-icon>mdi-redo</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        {{$translate(route.name)}}
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <add-page v-model="showAddPageDialog" />

        <v-btn
            @click="showAddPageDialog = true"
            color="zoezi-edit-color"
            fab
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn fab color="error" @click="removePage" v-if="canRemove" class="ml-4">
            <v-icon>mdi-delete</v-icon>
        </v-btn>
    </div>
</template>

<script>
import AddPage from './AddPage.vue'
export default {
    name: 'PageSettings',

    components: {
        AddPage
    },

    data: () => ({
        currentPanel: 0,
        showAddPageDialog: false,
        search: ''
    }),
    computed: {
        sortedRoutes() {
            let s = (this.search || '').toLowerCase();
            return this.$root.siteconfig.routes.map(r => r.props).filter(r => !s || r.path.includes(s) || r.name.toLowerCase().includes(s)).sort((a, b) => a.name.localeCompare(b.name));
        },
        canRemove() {
            return this.$route.path != '/';
        }
    },
    methods: {
        removePage() {
            let index = this.$root.siteconfig.routes.map(r => r.props).findIndex(x => x.path == this.$route.path);

            // Creates a map of redirect -> paths, {'/': ['/home', '/page2'], '/page1': ['/mypage']}
            const redirectRouteMap = this.$root.siteconfig.routes.reduce((redirectMap, { props: { redirect, path } }) => {
                if (!redirect) return redirectMap;
                redirectMap[redirect] = redirectMap[redirect] || [];
                redirectMap[redirect].push(path);
                return redirectMap;
            }, {});

            if (redirectRouteMap[this.$route.path]) {
                const pagesNames = this.$root.siteconfig.routes
                    .filter(r => redirectRouteMap[this.$route.path].includes(r.props.path))
                    .map(r => `\n ${r.props.name} (${r.props.path})`)

                this.$store.commit('showErrorDialog', {
                    title: this.$translate("Cannot remove page"),
                    text: this.$translate('The page {0} is used as a redirect for the following pages: {1}').format(
                        this.$route.path,
                        pagesNames.join(', ')
                    ),
                });
                return;
            }

            if (index != -1) {
                this.$store.commit('showConfirmDialog', {
                    title: this.$translate('Remove page'),
                    text: this.$translate('Are you sure you want to remove the page {0}?').format(`${this.$route.name} (${this.$route.path})`),
                    actionText: this.$translate('Delete'),
                    actionColor: 'error',
                    action: () => {
                        this.$root.siteconfig.routes.splice(index, 1);
                        this.$root.saveHomePage();

                        this.$root.followLink('/');
                    }
                });
            }
        },
    }
}
</script>
